import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable, NgZone } from '@angular/core';
import { Observable, of, Subject, throwError } from 'rxjs';
import { catchError, map, switchMap, tap } from 'rxjs/operators';
import { environment } from '../../../../../../environments/environment';
import { GroupsService } from '../../../../../groups/groups.service';
import { TechnadoptOrganizationInterface } from '../../../../../products/interfaces';
import { AddonDto, ConnectAppInterface } from '../../../../../shared/interfaces/connect-apps';
import { AuthService, AuthType } from '../../../../../shared/services/auth.service';
import { SharedService } from '../../../../../shared/shared.service';
import { AppType } from '../enums/enums';
import { apps } from './apps-list';
import { HigherAuthService } from '../../../../../shared/services/higher-auth.service';
import { TildaService } from 'src/app/shared/services/tilda.service';
import { ApplicationDefinition } from 'src/app/requests/esp/definitions/models/application-definition';
import { EspAuthService } from 'src/app/shared/services/esp-auth.service';
import { PlannexeDataProviderService } from 'src/app/plannexe/stemexe-providers.service';
import { Addon } from 'src/app/shared/models/addon.model';
import { UserService } from 'src/app/shared/services/user.service';
import moment from 'moment';

@Injectable({
  providedIn: 'root'
})
export class ConnectAppsService {
  msAuthTokenInstance$: Subject<any> = new Subject<any>();
  constructor(private http: HttpClient,
    private authService: AuthService,
    private groupService: GroupsService,
    private sharedService: SharedService,
    private espAuthService: EspAuthService,
    private plannexeDataProviderService: PlannexeDataProviderService,
    private ngZone: NgZone,
    private tildaService: TildaService,
    private higherAuthSrevice: HigherAuthService,
    private userService: UserService) { }


  getTechnadoptAccesslist(token): Observable<string> {
    const url = `${environment.technadoptApiHost}/webapi/api/security/accesslist/idenedi`;
    const options = {
      headers: new HttpHeaders({
        'Authorization': 'Bearer ' + token
      }),
      params: {
        groupIdenedi: this.authService.idenediGroupId
      }
    };
    return this.http.put<string>(url, {}, options)
  }

  ValidateGlobalSearchApiCreds(api_url:string): Observable<any> {
    const timestamp = new Date().getTime();
const url = `${api_url}/api/public-search`;
    const params: HttpParams = new HttpParams({
      fromObject: {
        group_id: this.authService.idenediGroupId,
        query: "test",
        timestamp: timestamp.toString()
        
      },
    });
    const options = {
      headers: new HttpHeaders({
        "Content-Type": "application/json"}),
      params,
    };
     return this.http.get<{ results: any[] }>(url, options);
  }

  disconnectApp(appInstanceId: string) {
    // return this.authService.getAddonsAuth(this.authService.idenediGroupId).pipe(switchMap(addons => {
    //   const addon = addons.find(a => a.Type.toLowerCase() == app.key.toLowerCase())
    //   if (addon) {
    return this.authService.deleteAddon(this.authService.idenediGroupId, appInstanceId);
    // }
    // throw throwError('addon not found')

  }
  createNewAddon(addon: any, groupId: string, type: string) {
    const timestamp = new Date().getTime();
    const authHeaders = this.authService.buildAuthHeader(AuthType.Idenedi);
    const options = {
      headers: authHeaders //.append("Idenedi-Api-Version", "4")
    };
    const payload = {
      ...addon,
      timestamp: timestamp.toString()
    };

    return this.http
      .post<any>(
        `${environment.apiHost}/api/group/${groupId}/addon?type=${type}`,
        payload,
        options
      )
      .pipe(
        tap(() => {
          this.sharedService.emitAddonUpdate();
        })
      );
  }

  getAddon(groupId: string, addonId: string) {
    const authHeaders = this.authService.buildAuthHeader(AuthType.Idenedi);
    const options = {
      headers: authHeaders //.append("Idenedi-Api-Version", "4")
    };
    return this.http
      .get<any>(
        `${environment.apiHost}/api/group/${groupId}/addon/${addonId}`,
        options
      );
  }
  updateAddon(addon: any, groupId: string, addonId: string) {
    const timestamp = new Date().getTime();
    const authHeaders = this.authService.buildAuthHeader(AuthType.Idenedi);
    const options = {
      headers: authHeaders //.append("Idenedi-Api-Version", "4")
    };
    const payload = {
      ...addon,
      timestamp: timestamp.toString()
    };
    return this.http
      .put<any>(
        `${environment.apiHost}/api/group/${groupId}/addon/${addonId}`,
        payload,
        options
      )
      .pipe(
        tap(() => {
          this.sharedService.emitAddonUpdate();
        })
      );
  }

  createAppDefaultAddon(type: AppType, organizationName) {
    let addon: AddonDto = {
      BaseUrl: '',
      AccessToken: '',
      RefreshToken: '',
      PrivateConfiguration: {},
      PublicProperties: {}

    }
    switch (type) {
      case AppType.Technadopt:
        addon = {
          BaseUrl: `${environment.technadoptApiHost}/webapi/`,
          AccessToken: "",
          RefreshToken: "",
          PrivateConfiguration: {
            domain: environment.technadoptApiHost,
            baseURL: `${environment.technadoptApiHost}/webapi/`,
            organziationId: "",
          },
          PublicProperties: {
            domain: environment.technadoptApiHost,
            baseURL: `${environment.technadoptApiHost}/webapi/`,
            groupIdenedi: this.authService.idenediGroupId,
            organziationId: "",
            organizationName: organizationName,
          }

        }
        break;
      
      case AppType.SimpleStrata:
        const domain = environment.isProduction ? 'https://ss-production-gateway.azurewebsites.net' : 'https://ss-staging-gateway.azurewebsites.net'
        addon = {
          BaseUrl: `${domain}/WebApi/`,
          AccessToken: "",
          RefreshToken: "",
          PrivateConfiguration: {
            domain: domain,
            baseURL: `${domain}/WebApi/`,
            organziationId: "",
          },
          PublicProperties: {
            domain: domain,
            baseURL: `${domain}/WebApi/`,
            groupIdenedi: this.authService.idenediGroupId,
            organziationId: "",
            organizationName: organizationName,
          }

        }
        break;
      case AppType.ESP:
        addon = {
          BaseUrl: `${environment.espApiHost}/WebApi/`,
          AccessToken: "",
          RefreshToken: "",
          PrivateConfiguration: {
            domain: environment.espApiHost,
            baseURL: `${environment.espApiHost}/WebApi/`,
            organziationId: "",
          },
          PublicProperties: {
            domain: environment.espApiHost,
            baseURL: `${environment.espApiHost}/WebApi/`,
            groupIdenedi: this.authService.idenediGroupId,
            organziationId: "",
            organizationName: organizationName,
          }

        }
        break;
      case AppType.VirtualRoom:
        addon = {
          Type: AppType.VirtualRoom,
          BaseUrl: `https://room.meetexe.com`,
          AccessToken: "",
          RefreshToken: "",
          PrivateConfiguration: {
            domain: '',
            organziationId: "",
          },
          PublicProperties: {
            domain: '',
            groupIdenedi: this.authService.idenediGroupId,
            organziationId: "",
            organizationName: '',
          },
          UserIdenedi: this.authService.getCurrentUserId()
        }
        break;
      case AppType.NotificationService:
        addon = {
          BaseUrl: '',
          AccessToken: "",
          RefreshToken: "",
          PrivateConfiguration: {
            organziationId: "",
          },
          PublicProperties: {
            groupIdenedi: this.authService.idenediGroupId,
            organziationId: "",
            organizationName: organizationName,
          }
        }
        break;
      case AppType.EngagementPro:
        const _domain = environment.production ? 'https://plannexe.exceeders.com/' : 'https://engpro2dev.azurewebsites.net/';
        addon = {
          BaseUrl: ``,
          AccessToken: "",
          RefreshToken: "",
          PrivateConfiguration: {
            domain: `${_domain}`,
            baseURL: ``,
            organziationId: "",
          },
          PublicProperties: {
            domain: `${_domain}`,
            baseURL: ``,
            groupIdenedi: this.authService.idenediGroupId,
            organziationId: "",
            organizationName: organizationName,
          }
        }
        break;
        case AppType.GlobalSearch:
         addon = {
          BaseUrl: '',
          AccessToken: "",
          RefreshToken: "",
          PrivateConfiguration: {
            organziationId: "",
          },
          PublicProperties: {
            groupIdenedi: this.authService.idenediGroupId,
            organziationId: "",
            organizationName: organizationName,
          }
        }
        break;
      default:
        break;
    }

    return addon;
  }
  defaultConnection(options: { type: AppType, groupName: string, vRoomId?: string, addonInstanceId?: string }): Observable<any> {
    let addon: any = this.createAppDefaultAddon(options.type, options.groupName);
    if (options.type == AppType.Technadopt) {
      return this.authService.getIdenediAuthorizationCodeForClient(environment.exceederClientId, this.authService.idenediGroupId).pipe(switchMap(code =>
        this.authService.getTokenByAuthorizationCode(addon.BaseUrl, code).pipe(switchMap(tokenRes =>
          this.getTechnadoptAccesslist(tokenRes.access_token).pipe(switchMap(orgId => {
            addon.PrivateConfiguration.organziationId = addon.PublicProperties.organziationId = orgId;
            return this.createNewAddon(addon, this.authService.idenediGroupId, options.type)

          }))
        ))
      ))

    } else if (options.type == AppType.SimpleStrata) {
      return this.groupService.getGroupPassword(this.authService.idenediGroupId).pipe(switchMap(idenediGroupPassword =>
        this.authService.getIdenediAuthorizationCodeForClient('XSS1977020300', this.authService.idenediGroupId).pipe(switchMap(IdenediCode =>
          this.getSimpleStrataOrganization(addon.BaseUrl, IdenediCode, options.groupName, this.authService.idenediGroupId, idenediGroupPassword).pipe(switchMap(ssOrg => {
            addon.PrivateConfiguration.organziationId = addon.PublicProperties.organziationId = ssOrg.ResponseResult.OrganizationId;
            return this.createNewAddon(addon, this.authService.idenediGroupId, options.type)
          }))
        ))

      ))
    } else if (options.type == AppType.ESP) {
      return this.defaultEspConnection(this.authService.idenediGroupId).pipe(switchMap(res => {
        return this.createOrLinkOrganization(this.authService.idenediGroupId, addon.BaseUrl).pipe(switchMap(orgId => {
          addon.PrivateConfiguration.organziationId = addon.PublicProperties.organziationId = orgId + '';
          return this.createNewAddon(addon, this.authService.idenediGroupId, options.type)

        }))
      }))
    }
     else if (options.type == AppType.GlobalSearch) {
      // return this.defaultEspConnection(this.authService.idenediGroupId).pipe(switchMap(res => {
        // return this.createOrLinkOrganization(this.authService.idenediGroupId, addon.BaseUrl).pipe(switchMap(orgId => {
        addon.PrivateConfiguration['api_url'] = addon.PublicProperties['api_url'];
        // addon.PrivateConfiguration['api_key'] = addon.PublicProperties['api_key'] = `${environment.aiintajyApiKey}`;

          // addon.PrivateConfiguration.organziationId = addon.PublicProperties.organziationId = orgId + '';
          return this.createNewAddon(addon, this.authService.idenediGroupId, options.type)

        // }))
      // }))
    }
    else if (options.type == AppType.VirtualRoom) {
      return this.getVirtualRoomAppUrl(addon.BaseUrl).pipe(switchMap(res => {
        addon.PrivateConfiguration['app_url'] = addon.PublicProperties['app_url'] = res['app_url'];
        addon.PrivateConfiguration['api_url'] = addon.PublicProperties['api_url'] = res['api_url'];
        if (options?.vRoomId) {
          addon.PublicProperties['RoomId'] = options?.vRoomId;
        }
        return this.createNewAddon(addon, this.authService.idenediGroupId, options.type);
      }))
    }
    else if (options.type == AppType.NotificationService) {
      const app = apps.find(app => app.key == AppType.NotificationService);
      const clientId = app.metaData.defaultLoginCredentials.username;
      const clientSecret = app.metaData.defaultLoginCredentials.password;
      addon.BaseUrl = addon.PublicProperties.baseURL = addon.PrivateConfiguration.baseURL = app.metaData.defaultLoginCredentials.apiUrl;
      return this.getNotificationServiceAppUrl(app.metaData.defaultLoginCredentials.apiUrl).pipe(switchMap(res => {
        addon.PublicProperties.authUrl = res?.authUrl;
        addon.PublicProperties.apiUrl = res?.apiUrl;
        addon.PublicProperties.client_id = clientId;
        addon.PrivateConfiguration.client_secret = clientSecret;
        addon.Type = AppType.NotificationService;
        addon.UserIdenedi = this.authService.getCurrentUserId();
        return this.getNSAccessToken(res?.authUrl, clientId, clientSecret).pipe(switchMap((response: any) => {
          return this.connectToStemexeGroup(res?.apiUrl,
            response?.access_token).pipe(switchMap(_ => {
              if (options.addonInstanceId) {
                return this.updateAddon(addon, this.authService.idenediGroupId, options.addonInstanceId)
              }
              return this.createNewAddon(addon, this.authService.idenediGroupId, options.type);
            }))
        }))
      }))
    }
    else if (options.type == AppType.EngagementPro) {
      return this.getAppBaseUrl(addon.PublicProperties?.domain).pipe(switchMap(res => {
        addon.PrivateConfiguration.baseURL = addon.PublicProperties.baseURL = res;
        return this.createOrganizationInPlannexe(res).pipe(catchError(err => {
          if (err?.error?.result) {
            addon.PublicProperties.organizationId = err.error.result;
            return this.setPlannexeAddon(addon);
          }
        }));
      }), switchMap(resp => {
        addon.PublicProperties.organizationId = resp;
        return this.setPlannexeAddon(addon);
      }))
    }
  }

  setPlannexeAddon(addonDto: AddonDto) {
    return this.authService.getAddonsAuth(this.authService.idenediGroupId).pipe(switchMap(addons => {
      const addon = addons.find(a => a.Type.toLowerCase() == AppType.EngagementPro.toLowerCase())
      if (addon) {
        return this.updateAddon(addonDto, this.authService.idenediGroupId, addon.InstanceId)
      }
      return this.createNewAddon(addonDto, this.authService.idenediGroupId, AppType.EngagementPro);
    }))
  }

  defaultEspConnection(groupId: string): Observable<any> {
    const url = `${environment.apiHost}/api/group/${groupId}/app`;
    const options = {
      headers: this.authService.buildAuthHeader(AuthType.Idenedi),
      params: new HttpParams({
        fromObject: {
          clientId: 'XSP1980031200'
        }
      })
    };
    return this.http.post<any>(url, {}, options);
  }

  createOrLinkOrganization(groupId, baseUrl: string) {
    const url = `${baseUrl}idenedigroup/LinkedOrganizationOrCreate/${groupId}`;
    return this.http.get<any>(url, {});
  }

  createOrganizationInPlannexe(baseUrl: string) {
    const body = {
      "OrganizationCode": "",
      "OrganizationName": "",
      "Idenedi": "",
      "FirstName": '',
      "LastName": "",
      "ProfileImageUrl": "",
      "CountryISOCode": '',
      "EntityType": "",
      "Email": "",
      "CreatedOnDate": moment(new Date()).locale('en').utc(true).format('YYYY-MM-DDTHH:mm:ssZ')
    }
    return this.userService.getUserDetail(this.authService.getCurrentUserId()).pipe(switchMap(res => {
      body.Idenedi = this.authService.getCurrentUserId();
      body.FirstName = res.Profile.FirstName;
      body.LastName = res.Profile.LastName;
      body.CountryISOCode = res.Profile.CountryISOCode;

      return this.groupService.getGroupDetails(this.authService.idenediGroupId)
    }), switchMap(grp => {
      body.OrganizationCode = this.authService.idenediGroupId;
      body.OrganizationName = grp?.Profile?.FirstName;
      const url = `${baseUrl}/api/Organization/AddOrgMain`;
      const authHeaders = this.authService.buildAuthHeader(AuthType.EngagementPro);
      const options = {
        headers: authHeaders.append("Content-Type", "application/json"),
      };
      return this.http.post<any>(url, body, options);
    }), catchError((e) => {
      throw e;
    }))
  }



  private getSimpleStrataOrganization(baseUrl: string, IdenediCode: string, OrganizationName: string, IdenediGroupId: string, IdenediGroupPassword: string): Observable<any> {
    const data = {
      IdenediCode,
      OrganizationName,
      IdenediGroupId,
      IdenediGroupPassword
    }
    return this.http.post(`${baseUrl}api/OrganizationApi/IdenediSignup`, data)
  }

  technadoptLogin(domain: string, username: string, password: string) {
    return this.getAppBaseUrl(domain).pipe(switchMap((baseUrl: string) => {
      domain = domain.trim();
      baseUrl = baseUrl.trim();
      return this._technadoptLogin(baseUrl, username, password).pipe(
        catchError((err) => {
          return throwError(err)
        })
      )
    }))
  }
  private _technadoptLogin(baseUrl: string, username: string, password: string): Observable<any> {
    const body = new HttpParams({
      fromObject: {
        username,
        password,
        grant_type: "password"
      }
    });
    const headers = new HttpHeaders({
      "Content-Type": "application/x-www-form-urlencoded"
    });
    return this.http.post(baseUrl + 'token', body.toString(), { headers })
      .pipe(map((res: any) => { res.baseUrl = baseUrl; return res }));
    // return this.http.post(domain, { username, password, grant_type: 'password' })
  }

  getTechnadoptOrganizations(baserurl: string, accessToken: string): Observable<TechnadoptOrganizationInterface[]> {
    const options = {
      headers: new HttpHeaders({
        'Authorization': 'Bearer ' + accessToken
      })
    }
    return this.http.get<TechnadoptOrganizationInterface[]>(baserurl + 'api/accesslist', options)
  }

  fetchTechnadoptOrganizations(accesslist?: string): Observable<TechnadoptOrganizationInterface[]> {
    const authHeaders = this.authService.buildAuthHeader(AuthType.Technadopt);

    const options: { headers: HttpHeaders; params?: HttpParams } = {
      headers: authHeaders
    };

    if (accesslist && accesslist.trim()) {
      options.params = new HttpParams({
        fromObject: {
          accesslist: accesslist.trim()
        }
      });
    }

    return this.http.get<TechnadoptOrganizationInterface[]>('api/accesslist/GetAccessList', options);
  }

  public getAppBaseUrl(domain: string): Observable<string> {
    domain = domain.trim();
    if (!domain.endsWith('/')) {
      domain = domain + '/';
    }
    const url = `${domain}baseurl.txt`;
    const options: Object = {
      responseType: 'text'
    }
    return this.http.get<string>(url, options).pipe(map((baseUrl: string) => baseUrl.replace(/\r?\n|\r/g, '').trim()))
  }

  getVirtualRoomAppUrl(domain: string): Observable<any> {
    domain = domain.trim();
    if (!domain.endsWith('/')) {
      domain = domain + '/';
    }
    const url = `${domain}hosts.json`;

    return this.http.get(url);
  }

  getNotificationServiceAppUrl(domain: string): Observable<any> {
    domain = domain.trim();
    if (!domain.endsWith('/')) {
      domain = domain + '/';
    }
    const url = `${domain}hosts.txt`;

    return this.http.get(url);
  }

  getNSAccessToken(baseUrl: string, clientId: string,
    clientSecret: string) {
    if (!baseUrl.endsWith('/')) {
      baseUrl = baseUrl + '/';
    }
    const body = new HttpParams({
      fromObject: {
        client_id: clientId,
        client_secret: clientSecret,
        grant_type: "client_credentials",
      }
    });
    const headers = new HttpHeaders({
      "Content-Type": "application/x-www-form-urlencoded"
    });
    return this.http.post(`${baseUrl}connect/token`, body.toString(), { headers })
  }

  connectToStemexeGroup(baseUrl: string, accessToken: string) {
    if (!baseUrl.endsWith('/')) {
      baseUrl = baseUrl + '/';
    }
    return this.groupService.getGroupDetails(this.authService.idenediGroupId).pipe(switchMap(res => {
      const body = {
        "groupName": res?.Profile?.FirstName,
      };
      const headers = new HttpHeaders({
        "Content-Type": "application/json",
        "Authorization": `Bearer ${accessToken}`
      });
      return this.http.post(`${baseUrl}api/groups/${this.authService.idenediGroupId}/link`, body, { headers })
    }))
  }

  espLogin(baseUrl: string, username: string, password: string): Observable<any> {
    baseUrl = baseUrl.trim();
    if (baseUrl.endsWith('/')) {
      baseUrl = baseUrl + 'webapi/'
    } else {
      baseUrl = baseUrl + '/webapi/'
    }
    const body = new HttpParams({
      fromObject: {
        username,
        password,
        grant_type: "password",
        client_id: 'ESPWeb'
      }
    });
    const headers = new HttpHeaders({
      "Content-Type": "application/x-www-form-urlencoded"
    });
    return this.http.post(baseUrl + "token", body.toString(), { headers })
      .pipe(map((res: any) => {
        res.baseUrl = baseUrl;
        return res
      }));
    // return this.http.post(domain, { username, password, grant_type: 'password' })
  }
  simpleStrataLogin(baseUrl: string, username: string, password: string): Observable<any> {
    baseUrl = baseUrl.trim();
    if (baseUrl.endsWith('/')) {
      baseUrl = baseUrl + 'webapi/'
    } else {
      baseUrl = baseUrl + '/webapi/'
    }
    const body = new HttpParams({
      fromObject: {
        username,
        password,
        grant_type: "password",
        client_id: 'web',
        deviceTypeId: '1',
        client_secret: 'S#%234$#a!@6Qsd&'
      }
    });
    const headers = new HttpHeaders({
      "Content-Type": "application/x-www-form-urlencoded"
    });
    return this.http.post(baseUrl + "token", body.toString(), { headers })
      .pipe(map((res: any) => {
        res.baseUrl = baseUrl;
        return res
      }));
    // return this.http.post(domain, { username, password, grant_type: 'password' })
  }
  getSimpleStrataOrganizations(baseUrl, accessToken): Observable<any[]> {
    return this.http.get<any[]>(`${baseUrl}api/OrganizationApi/GetAllForSignIn`,
      {
        headers: {
          Authorization: `Bearer ${accessToken}`
        }
      }).pipe(map((res: any) => {
        // let dummyData = {
        //   Id: 1,
        //   IsHidden: true,
        //   Name: 'Current Organization',
        //   IdenediGroupId: 'GQD1959070200',
        // }
        // res.ResponseResult.push(dummyData);

        let organizations = res.ResponseResult;
        let currentOrganization = organizations.find(org => org.IdenediGroupId == this.authService.idenediGroupId);
        let currentOrganizationIndex = organizations.findIndex(org => org.IdenediGroupId == this.authService.idenediGroupId);
        if (currentOrganization) {
          organizations.splice(currentOrganizationIndex, 1);
          organizations.unshift(currentOrganization);
        }
        return organizations
      }))
  }
  getEspOrganizations(baseUrl, accessToken, groupId): Observable<any[]> {

    return this.http.get<any[]>(`${baseUrl}idenedigroup/linkablePersonas/${groupId}`, {
      headers: {
        Authorization: `Bearer ${accessToken}`
      }
    })
  }

  linkToEsp(baseUrl, accessToken, groupId, espOrgId) {
    return this.http.put<any>(`${baseUrl}idenedigroup/linkMainIdenedi/${groupId}/${espOrgId}`, {}, {
      headers: {
        Authorization: `Bearer ${accessToken}`
      }
    })
  }


  getEspServiceFields(baseUrl: string, accessToken: string, serviceId: string): Observable<any[]> {
    const url = `${baseUrl}/fields/availableFields/definition?defintionId=${serviceId}&sectionId=0&stageId=0&isIncludeCurrentStage=false`;
    return this.http.get<any[]>(url,
      {
        headers: {
          Authorization: `Bearer ${accessToken}`
        }
      })
  }
  higherLogin(baseUrl: string, username: string, password: string): Observable<any> {
    baseUrl = baseUrl.toLowerCase().trim();

    if (baseUrl.endsWith('/v2') || baseUrl.endsWith('/v2/')) {
      baseUrl.replace('/v2', '')
    }
    if (baseUrl.endsWith('/')) {
      baseUrl = baseUrl + 'webapi/'
    } else {
      baseUrl = baseUrl + '/webapi/'
    }
    const body = new HttpParams({
      fromObject: {
        username,
        password,
        grant_type: "password",
        client_id: 'higherWeb',
        callFrom: 'group'
      }
    });
    const headers = new HttpHeaders({
      "Content-Type": "application/x-www-form-urlencoded"
    });
    return this.http.post(baseUrl + "token", body.toString(), { headers })
      .pipe(map((res: any) => {
        res.baseUrl = baseUrl;
        return res
      }));

  }
  getHigherTeams(baseUrl, accessToken, orgId?): Observable<any[]> {

    return this.http.get<any[]>(`${baseUrl}api/organizationteam/get-teams/${orgId}`, {
      headers: {
        Authorization: `Bearer ${accessToken}`,
        OrganizationId: orgId
      }
    })
  }

  getHigherOrganizations(baseUrl, accessToken): Observable<any[]> {
    //return this.http.post<any[]>(`${baseUrl}api/organization/getOrganization`, {}, {
    return this.http.post<any[]>(`${baseUrl}api/organization/get-organizations`, {}, {
      headers: {
        Authorization: `Bearer ${accessToken}`
      }
    }).pipe(map(orgs => {
      if (!Array.isArray(orgs)) {
        orgs = [orgs];
      }
      return orgs;
    }))
  }

  intajyLogin(baseUrl: string, username: string, password: string): Observable<any> {
    baseUrl = baseUrl.toLowerCase().trim();
    if (baseUrl.startsWith('https://')) { baseUrl = baseUrl.replace('https://', '') }
    if (baseUrl.startsWith('http://')) { baseUrl = baseUrl.replace('http://', '') }

    const params = new HttpParams({
      fromObject: {
        username,
        password,
        domain: baseUrl
      }
    });
    ;
    return this.http.get<any>(`${environment.intajyAppUrl}/v1/verify-admin`, { params })
      .pipe(map((res: any) => res.data
      ));

  }

  leadLineLogin(baseUrl: string, username: string, password: string): Observable<any> {
    return this.http.get<any>(`${baseUrl}/tenant/GetTennantUrl?userUniqueIdentifier=${username}`).pipe(switchMap(
      response => {
        let responseData = {
          customHeader: response[0]?.customHeader,
          tennantMapUrl: response[0]?.tennantMapUrl,
          domain: baseUrl,
          password: password
        }
        const headers = new HttpHeaders({
          "Content-Type": "application/x-www-form-urlencoded",
          "customheader": responseData.customHeader
        });
        const body = new HttpParams({
          fromObject: {
            grant_type: 'password',
            username: username,
            password: password,
            authenticationmode: 'custom'
          }
        });

        return this.http.post(`${responseData.tennantMapUrl}/token`, body.toString(), { headers }).pipe(map((r: any) => {
          responseData['accessToken'] = r['access_token']
          return responseData;
        }))
      }))
  }

  getLeadLineProducts(baseUrl: string, customHeader: string) {
    const headers = new HttpHeaders({
      "Content-Type": "application/x-www-form-urlencoded",
      "customheader": customHeader
    });

    return this.http.get<any>(`${baseUrl}/GetAllProductForGitex`, { headers });
  }

  postLeadLineActions(baseUrl: string, customHeader: string, productId: number) {
    const headers = new HttpHeaders({
      "Content-Type": "application/json",
      "customheader": customHeader
    });
    return this.http.post<any>(`${baseUrl}/GetProductActionByIdForStemexe?ProductId=${productId}`, {}, { headers });
  }

  generateChatBotToken(secret: string) {
    return this.http.post<any>('https://directline.botframework.com/v3/directline/tokens/generate',
      {
        user:
          { id: 'web', name: 'webuser' }
      },
      {
        headers: {
          Authorization: `Bearer ${secret}`
        }
      }
    )
  }

  private _linkAccount(groupId: string, provider: string, scope, redirectUri: string, code: string) {

    const authHeaders = this.authService.buildAuthHeader(AuthType.Idenedi);
    const options = {
      headers: authHeaders
    };
    const data = {
      Provider: provider,
      Scope: scope,
      RedirectUri: redirectUri,
      Code: code
    }
    return this.http
      .post<any>(`${environment.apiHost}/api/group/${groupId}/linkedaccount`, data, options);

  }
  private _getLinkedAccounts(groupId: string): Observable<any[]> {

    const authHeaders = this.authService.buildAuthHeader(AuthType.Idenedi);
    const options = {
      headers: authHeaders
    };
    return this.http
      .get<any[]>(`${environment.apiHost}/api/group/${groupId}/linkedaccount`, options);

  }

  getMicrosoftAccessToken(groupId: string, provider: string, scope, redirectUri: string, code: string) {
    return this._linkAccount(groupId, provider, scope, redirectUri, code)
      .pipe(switchMap(accountId =>
        this._getLinkedAccounts(groupId)
          .pipe(map(accounts => accounts.find(ac => ac.InstanceId == accountId)))
      ))

  }

  getPoweBiWorkplaces(accessToken: string) {
    const url = `https://api.powerbi.com/v1.0/myorg/groups`;
    const authHeaders = new HttpHeaders({
      'Authorization': `Bearer ${accessToken}`
    });
    const options = {
      headers: authHeaders
    };
    return this.http.get<any>(url, options).pipe(map(res => {
      if (res) {
        return res.value;
      }
      return [];
    }))
  }

  handleMicrosoftLogin(scope: string[]) {
    return this.authService.getIdenediAccountProvider('microsoft')
      .pipe(map(provider => provider.ClientId), tap((clientId) => {
        this.handleMSAuthPopup(clientId, scope);
      }))
  }

  handleMSAuthPopup(clientId: string, scope: string[]) {
    const redirectUrl = environment.production ? 'https://app.idenedi.com/msog-auth' : 'https://idenedi-prod-stag.azurewebsites.net/msog-auth';
    let popup: Window;
    window['HandleMSAuthCode'] = (msAuthCode) => {
      this.ngZone.run(() => {
        if (popup) {
          popup.close();
        }
        this.getMicrosoftAccessToken(this.authService.idenediGroupId, 'microsoft', encodeURIComponent(scope.join(' ')), redirectUrl, msAuthCode)
          .pipe(map(res => {
            this.msAuthTokenInstance$.next(res);
            return res;
          })).subscribe()
      })
    }

    const state = `${window.location.protocol}//${window.location.host}/assets/msog-auth.html`;
    const url = `https://login.microsoftonline.com/common/oauth2/v2.0/authorize?
    response_mode=query
    &response_type=code
    &prompt=select_account
    &client_id=${clientId}
    &redirect_uri=${encodeURIComponent(redirectUrl)}
    &scope=${encodeURIComponent(scope.join(' '))}
    &state=${encodeURIComponent(state)}`;

    const h = 580;
    const w = 460;
    const x = screen.width / 2 - w / 2;
    const y = screen.height / 2 - h / 2;
    popup = window.open(url, 'microsoft', `popup=true,height=${h},width=${w},left=${x},top=${y}`);
    popup.opener = window;
    popup.focus();
  }

  getPoweBiDashboards(accessToken: string, workplaceId: string) {
    const url = `https://api.powerbi.com/v1.0/myorg/groups/${workplaceId}/dashboards`;
    const authHeaders = new HttpHeaders({
      'Authorization': `Bearer ${accessToken}`
    });
    const options = {
      headers: authHeaders
    };
    return this.http.get<any>(url, options)
      .pipe(map((res: { value: any[] }) => {
        if (res && res.value) {

          return res.value.map(db => {
            db.groupId = workplaceId
            return db;
          });
        }
        return [];
      }))
  }
  getPoweBiReports(accessToken: string, workplaceId: string) {
    const url = `https://api.powerbi.com/v1.0/myorg/groups/${workplaceId}/reports`;
    const authHeaders = new HttpHeaders({
      'Authorization': `Bearer ${accessToken}`
    });
    const options = {
      headers: authHeaders
    };
    return this.http.get<any>(url, options)
      .pipe(map((res: { value: any[] }) => {
        if (res && res.value) {

          return res.value.map(rpt => {
            rpt.groupId = workplaceId;
            rpt.displayName = rpt.name;
            return rpt;
          });
        }
        return [];
      }))
  }
  getConnectAppsItems(filter?: {
    key?: AppType[];
    excluded?: AppType[];
  }): ConnectAppInterface[] {
    const defaultApps = JSON.parse(JSON.stringify(apps));
    if (filter?.key.length) {
      return defaultApps.filter(t => filter?.key?.includes(t.key));
    }
    if (filter?.excluded?.length) {
      return defaultApps.filter(t => !filter?.excluded?.includes(t.key));
    }
    return defaultApps;
  }

  getOppproOrganizations(baserurl: string): Observable<any[]> {
    return this.authService.getIdenediAuthorizationCodeForClient(environment.oppProClientId, this.authService.idenediGroupId).pipe(switchMap((authCode: string) => {
      return this.http.get<any[]>(baserurl + `/GetTenantUrlByIdenediAuthCode?ClientCode=${environment.oppProClientCode}&authorizationCode=${authCode}`);
    }))
  }


  connectGroupHigher(baseUrl, accessToken, data): Observable<any[]> {
    // webapi/api/organizationteam/get-all-teams
    return this.http.post<any[]>(`${baseUrl}api/setting/connect-group`, data, {
      headers: {
        Authorization: `Bearer ${accessToken}`
      }
    }).pipe(map(orgs => {
      if (!Array.isArray(orgs)) {
        orgs = [orgs];
      }
      return orgs;
    }))
  }

  disconnectGroupHigher(baseUrl, data): Observable<any[]> {
    // webapi/api/organizationteam/get-all-teams
    let userInfo = this.higherAuthSrevice.getHigherUserInfo()
    return this.http.post<any[]>(`${baseUrl}api/setting/disconnect-group`, data).pipe(map(orgs => {
      if (!Array.isArray(orgs)) {
        orgs = [orgs];
      }
      return orgs;
    }))
  }

  updateConnectedGroupHigher(baseUrl, accessToken, data): Observable<any[]> {
    // webapi/api/organizationteam/get-all-teams
    return this.http.post<any[]>(`${baseUrl}api/setting/update-connect-group`, data, {
      headers: {
        Authorization: `Bearer ${accessToken}`
      }
    }).pipe(map(orgs => {
      if (!Array.isArray(orgs)) {
        orgs = [orgs];
      }
      return orgs;
    }))
  }


  getTildaOrganizations(publickey: string, secretkey: string) {
    return this.tildaService.getTildaProjects(publickey, secretkey);
  }

  getEspServices(recordType: boolean = false): Observable<any[]> {
    const options = {
      headers: this.authService.buildAuthHeader(AuthType.ESP),
    };

    if (recordType) {
      options['params'] = new HttpParams({
        fromObject: {
          type: 'record'
        }
      })
    }
    return this.espAuthService.getEspToken().pipe(switchMap(_ => {
      return this.http.get<any[]>(`category/AllWithQuery`, options).pipe(
        map((res: any[]) => {
          return res.map(res => res.definitions).flat()
        })
      );
    }));
  }

  getEspRequests(): Observable<any> {
    return this.espAuthService.getEspToken().pipe(switchMap(_ => {
      return this.http
      .get<ApplicationDefinition[]>(`/definition`, {
          headers: this.authService.buildAuthHeader(AuthType.ESP)
        })
        .pipe(
          map(apps => {
            if (apps.length) {
              return apps.filter(
                app => app.isPublished && app.publishedVersion > 0
              );
            }
            return apps;
          })
        )
    }));

  }

  getEspTechnadoptTopicDefinitions(): Observable<any> {
    return this.espAuthService.getEspToken().pipe(switchMap(_ => {
      return this.http
      .get<ApplicationDefinition[]>(`/technadopt/TopicDefinitions`, {
          headers: this.authService.buildAuthHeader(AuthType.ESP)
        })
        .pipe(
          map(apps => {
            return apps || [];
          })
        )
    }));

  }


  getPlannexeProjects(): Observable<any> {
    return this.plannexeDataProviderService.getPlannexeBaseUrl().pipe(
      switchMap(baseUrl => this.http.post(`${baseUrl}/api/Project/GetAllProjectsMini`, {}, this.plannexeDataProviderService.getURLHeaders())),
      map((result: any) => {
        if (result?.result) {
          return result.result.map((r: any) => ({
            id: r.projectId,
            name: r.projectName
          }));
        }
        return [];
      })
    );
  }

  getSSScoreCards(): Observable<any> {
    const url = `api/OrganizationApi/GetScoreCard`;
    const data = {
      PageIndex: 1,
      PageSize: 100,
      IncludeAllUserBoards: false,
      Keyword: '',
      OwnerUserId: 0
    };
    return this.http.post<any>(url, data, {
      headers: this.authService.buildAuthHeader(AuthType.SimpleStrata)
    }).pipe(
      map((result: any) => {
        if (result?.Data) {
          return result.Data.map((r: any) => ({
            id: r.TeamId,
            name: r.Name
          }));
        }
        return [];
      })
    );
  }

  getApplicationDetails(applicationId: number, forSingleTab = false, filledFormId: number = 0, revise: boolean = false): Observable<any> {
    let revised = revise ? 'yes'  : ''
    return this.espAuthService.getEspToken().pipe(switchMap(_ => {
      return this.http.get<any>(`/application/detailsv3/${applicationId}/${false}/${false}/${forSingleTab}?ffId=${filledFormId}&revise=${revised}`, { observe: 'response', headers: this.authService.buildAuthHeader(AuthType.ESP) });
    }));

  }
  getFieldsForDefinitionConditional(stageId: number, definitionId: number, isIncludeCurrentStage: boolean = false, sectionId: number = 0, forInsertableFields = false, apiVersion: string = ''): Observable<any>{
    if (!stageId) {
      stageId = 0;
    }
    // let headers = this.commonHelperService.getCurrentLocaleHeader();
    // headers.append(AUTH_TYPE_HEADER, AuthType.ESP);
    // // headers = headers.set('cache-request', 'true')
    let queryString = '';
    if(forInsertableFields){
      queryString += '&level=1';
    }
    return this.espAuthService.getEspToken().pipe(switchMap(_ => {
      return this.http.get<any>(`/fields/availableFields${apiVersion}/definition?defintionId=${definitionId}&sectionId=${sectionId}&stageId=${stageId}&isIncludeCurrentStage=${isIncludeCurrentStage}${queryString}`, { headers: this.authService.buildAuthHeader(AuthType.ESP), observe: 'response' })
        .pipe(
          map(apps => {
            
            return apps;
          })
        )
    }));
  }

}
